import { format } from 'date-fns';
import type { VacationApprovedPeriod, VacationDpRow } from '../models/vacationDpBoard.types';

/** Qualquer dia do período cai dentro da chave (ano ou mês). Generaliza `periodOverlapsMonth`. */
export function periodOverlapsKey(period: VacationApprovedPeriod, key: string): boolean {
    if (!key) return true;
    const startSlice = period.startDate.slice(0, key.length);
    const endSlice = period.endDate.slice(0, key.length);
    return startSlice <= key && endSlice >= key;
}

/** O período começa naquele mês — usado no relatório, que lista só quem entra de férias. */
export function periodStartsInMonth(period: VacationApprovedPeriod, monthKey: string): boolean {
    return period.startDate.slice(0, 7) === monthKey;
}

/** Aceita chave de ano (`'2026'`) ou mês (`'2026-09'`); vazio retorna tudo. */
export function filterRowsByPeriod(rows: VacationDpRow[], key: string): VacationDpRow[] {
    if (!key) return rows;

    return rows.filter((row) =>
        row.approvedPeriods.some((period) => periodOverlapsKey(period, key))
    );
}

/** Nomes fixos em português — o modal de exportação escolhe mês e ano em selects separados. */
export const MONTH_NAMES = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
] as const;

export function buildYearOptions(today: Date = new Date()): number[] {
    const year = today.getFullYear();
    return [year, year + 1, year + 2];
}
